import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { setSnackBarAlert } from "../../../../store/one-query/chatsSlice";
import { useNavigate } from "react-router-dom";
import "../../views/MainPage.css";
import useNavigateToMainPage from "../../../../NavigateToMainPage";
import { Box, Slide, SlideProps } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Check } from "@mui/icons-material";
interface SnackBarProps {
  showSnackBar: boolean;
  snackBarMessage: string;
  snackMessageBody?: string;
  snackType?: "error" | "warning" | "info" | "success";
  position?: {
    vertical: "top" | "bottom";
    horizontal: "left" | "center" | "right";
  };
}

const SnackBarAlert = ({
  showSnackBar,
  snackBarMessage,
  snackType,
  snackMessageBody,
  position = { vertical: "bottom", horizontal: "right" }, // Default position
}: SnackBarProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const navigateToMainPage = useNavigateToMainPage();

  function SlideTransition(props:SlideProps) {
  return <Slide {...props} direction="left" />;
}

  useEffect(() => {
    if (snackBarMessage === "This conversation doesn't exist.") {
      navigateToMainPage();
    }
    if (showSnackBar) {
      const timer = setTimeout(() => {
        handleCloseSnackbar();
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [showSnackBar]);

  const handleCloseSnackbar = () => {
    dispatch(
      setSnackBarAlert({
        show: false,
        message: "",
        alertType: "success",
        messageBody: "",
      })
    );
  };

  return (
    <Box>
      <Snackbar
        open={showSnackBar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={position}
        TransitionComponent={SlideTransition} 
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackType}
          variant="filled"
          iconMapping={{
            success:<Check/>,
          }}
          sx={{
            width: "100%",
            fontSize: "14px",
            fontWeight: "400",
            color: "var(--M-fontColor38)",
            fontFamily: "Roboto",
            backgroundColor: "var(--popupBackground)",
            borderBottom: `5px solid ${
              snackType === "error"
                ? "var(--snackError)"
                : snackType === "warning"
                ? "var(--snackWarning)"
                : snackType === "success"
                ? "var(--snackSuccess)"
                : "#1976D2"
            }`,
            borderRadius: "8px",
            boxShadow:"var(--snackBoxShadow)",
            "& .MuiAlert-icon": {
              color:
               snackType === "error"
                  ? "var(--snackError)"
                  : snackType === "warning"
                  ? "var(--snackWarning)"
                  : snackType === "success"
                  ? "var(--snackSuccess)"
                  : "#1976D2",
            },
          }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SnackBarAlert;
